export default __webpack_public_path__ + "static/media/kingfisher.2c1e8a7c.jpg";